export default __webpack_public_path__ + "static/media/pack.d59b9185.svg";